import Async from './Async'

export default Async(
  () => import(/* webpackChunkName: "LeafletMap" */ './LeafletMapSync')
)
